module.exports = __webpack_public_path__ + "img/trubadur.26528830.jpg";